import jApi from './jApi';

export default {
  updateEducationInformation(id, dataId, data) {
    const api = jApi.generateApi();
    return api.patch(`/hris-employee-service/employees/${id}/educations/${dataId}`, data);
  },

  deleteEducationInformation(id, dataId) {
    const api = jApi.generateApi();
    return api.delete(`/hris-employee-service/employees/${id}/educations/${dataId}`);
  },

  addEducationInformation(id, data) {
    const api = jApi.generateApi();
    return api.post(`/hris-employee-service/employees/${id}/educations`, data);
  },

  getListEducationInformation(employeeId) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${employeeId}/educations`).then(res => res).catch(e => e);
  },

  getEmergencyContacts(employeeId) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${employeeId}/emergency_contacts`).then(res => res).catch(e => e);
  },

  createEmergencyContacts(employeeId, data) {
    const api = jApi.generateApi();
    return api.post(`hris-employee-service/employees/${employeeId}/emergency_contacts`, data);
  },

  updateEmergencyContacts(id, dataId, data) {
    const api = jApi.generateApi();
    return api.patch(`hris-employee-service/employees/${id}/emergency_contacts/${dataId}`, data);
  },

  deleteEmergencyContacts(id, dataId) {
    const api = jApi.generateApi();
    return api.delete(`hris-employee-service/employees/${id}/emergency_contacts/${dataId}`);
  },

  getFamilyRelations(id) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${id}/family_relations`).then(res => res).catch(e => e);
  },
  postFamilyRelation(id, data) {
    const api = jApi.generateApi();
    return api.post(`/hris-employee-service/employees/${id}/family_relations`, data);
  },
  deleteFamilyRelation(id, dataId) {
    const api = jApi.generateApi();
    return api.delete(`/hris-employee-service/employees/${id}/family_relations/${dataId}`);
  },
  updateFamilyRelation(id, dataId, data) {
    const api = jApi.generateApi();
    return api.patch(`/hris-employee-service/employees/${id}/family_relations/${dataId}`, data);
  },

  getBusinessLines(id) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${id}/business_line`).then(res => res).catch(e => e);
  },
  createBusinessLine(id, data) {
    const api = jApi.generateApi();
    return api.post(`/hris-employee-service/employees/${id}/business_lines`, data)
      .then(res => res);
  },
  updateBusinessLine(userId, businessLineId, data) {
    const api = jApi.generateApi();
    return api.patch(`/hris-employee-service/employees/${userId}/business_lines/${businessLineId}`, data)
      .then(res => res);
  },
  deleteBusinessLine(userId, businessLineId) {
    const api = jApi.generateApi();
    return api.delete(`/hris-employee-service/employees/${userId}/business_lines/${businessLineId}`)
      .then(res => res);
  },

  viewOneMedicalInformation(id) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${id}/medical_informations/last`);
  },
  postMedicalInformation(id, data) {
    const api = jApi.generateApi();
    return api.post(`/hris-employee-service/employees/${id}/medical_informations`, data);
  },

  getMedicalRecords(id) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${id}/medical_records`).then(res => res).catch(e => e);
  },
  deleteMedicalRecord(id, dataId) {
    const api = jApi.generateApi();
    return api.delete(`/hris-employee-service/employees/${id}/medical_records/${dataId}`);
  },
  postMedicalRecord(id, data) {
    const api = jApi.generateApi();
    return api.post(`/hris-employee-service/employees/${id}/medical_records`, data);
  },
  updateMedicalRecord(id, dataId, data) {
    const api = jApi.generateApi();
    return api.patch(`/hris-employee-service/employees/${id}/medical_records/${dataId}`, data);
  },

  getEmployeeDocuments(id, limit, page, column, ascending) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${id}/documents?limit=${limit}&page=${page}&column=${column}&ascending=${ascending}`).then(res => res).catch(e => e);
  },
  deleteEmployeeDocument(id, dataId) {
    const api = jApi.generateApi();
    return api.delete(`/hris-employee-service/employees/${id}/documents/${dataId}`);
  },
  postEmployeeDocument(id, data) {
    const api = jApi.generateApi();
    return api.post(`/hris-employee-service/employees/${id}/documents`, data);
  },
  updateEmployeeDocument(id, dataId, data) {
    const api = jApi.generateApi();
    return api.patch(`/hris-employee-service/employees/${id}/documents/${dataId}`, data);
  },

  getCareerHistories(id) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${id}/careers`).then(res => res).catch(e => e);
  },
  deleteCareerHistory(id, dataId) {
    const api = jApi.generateApi();
    return api.delete(`/hris-employee-service/employees/${id}/careers/${dataId}`);
  },
  postCareerHistory(id, data) {
    const api = jApi.generateApi();
    return api.post(`/hris-employee-service/employees/${id}/careers`, data);
  },
  updateCareerHistory(id, dataId, data) {
    const api = jApi.generateApi();
    return api.patch(`/hris-employee-service/employees/${id}/careers/${dataId}`, data);
  },

  getTrackRecords(id) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${id}/track_records`).then(res => res).catch(e => e);
  },
  deleteTrackRecord(id, dataId) {
    const api = jApi.generateApi();
    return api.delete(`/hris-employee-service/employees/${id}/track_records/${dataId}`);
  },
  postTrackRecord(id, data) {
    const api = jApi.generateApi();
    return api.post(`/hris-employee-service/employees/${id}/track_records`, data);
  },
  updateTrackRecord(id, dataId, data) {
    const api = jApi.generateApi();
    return api.patch(`/hris-employee-service/employees/${id}/track_records/${dataId}`, data);
  },

  getUsedFacilitiesOnBoarding(id, limit = '', page = '', column = '', ascending = '') {
    const api = jApi.generateApi();
    return api.get(
      `/hris-assets-service/employees/${id}/used_facilities?limit=${limit}&page=${page}&column=${column}&ascending=${ascending}`,
    );
  },
  getAllUsedFacilitiesOnboarding(id, limit = '', page = '', column = '', ascending = '') {
    const api = jApi.generateApi();
    return api.get(
      `hris-assets-service/facilities?limit=${limit}&page=${page}&column=${column}&ascending=${ascending}`);
  },
  getFacilitiesOnBoarding(id, limit = '', page = '', column = '', ascending = '') {
    const api = jApi.generateApi();
    return api.get(
      `/hris-assets-service/facilities?limit=${limit}&page=${page}&column=${column}&ascending=${ascending}&used_by=${id}`,
    );
  },
  createFacilitiesOnBoarding(id, data) {
    const api = jApi.generateApi();
    return api.post(
      `/hris-assets-service/employees/${id}/used_facilities`, data,
    );
  },
  putFacilitiesOnBoarding(id, facilityId, data) {
    const api = jApi.generateApi();
    return api.put(
      `/hris-assets-service/employees/${id}/used_facilities/${facilityId}/state`, data,
    );
  },

  getSelfDevelopments(id, limit, page, column, ascending) {
    const api = jApi.generateApi();
    return api.get(`/hris-employee-service/employees/${id}/self_developments?limit=${limit}&page=${page}&column=${column}&ascending=${ascending}`).then(res => res).catch(e => e);
  },
  deleteSelfDevelopment(id, dataId) {
    const api = jApi.generateApi();
    return api.delete(`/hris-employee-service/employees/${id}/self_developments/${dataId}`);
  },
  postSelfDevelopment(id, data) {
    const api = jApi.generateApi();
    return api.post(`/hris-employee-service/employees/${id}/self_developments`, data);
  },
  updateSelfDevelopment(id, dataId, data) {
    const api = jApi.generateApi();
    return api.patch(`/hris-employee-service/employees/${id}/self_developments/${dataId}`, data);
  },


  listEmployee(req) {
    const api = jApi.generateApi();
    return api.post('user/studio/employee/list', req)
      .then(res => res);
  },

  createEmployee(req) {
    const apis = jApi.generateApi();
    return apis.post('user/employee/create', req)
      .then(res => res.data);
  },

  createEmployeeAuthService(req) {
    const apis = jApi.generateApi();
    return apis.post('auth-service/employee/create', req)
      .then(res => res.data);
  },

  detailEmployee(req) {
    const apis = jApi.generateApi();
    return apis.post('user/employee/detail-pro', req)
      .then(res => res.data);
  },

  updateEmployee(req) {
    const apis = jApi.generateApi();
    return apis.post('user/studio/employee/update', req)
      .then(res => res.data);
  },

  updateWithReason(id, req) {
    const apis = jApi.generateApi();
    return apis.post(`user/employee/update-with-reasons/${id}`, req)
      .then(res => res.data);
  },

  changePasswordEmployee(req) {
    const apis = jApi.generateApi();
    return apis.post('auth-service/admin/employee/change-password', req)
      .then(res => res.data);
  },

  deleteEmployee(req) {
    const apis = jApi.generateApi();
    return apis.post('user/studio/employee/delete-bulk', req)
      .then(res => res.data);
  },

  listEmployeeType(req) {
    const apis = jApi.generateApi();
    return apis.get('user/employee/employment-type/list', req)
      .then(res => res.data);
  },

  listBank(req) {
    const apis = jApi.generateApi();
    return apis.post('integration-bank/bank/list', req)
      .then(res => res.data);
  },

  listCompany(req) {
    const apis = jApi.generateApi();
    return apis.post('company/setup/location/list', req)
      .then(res => res.data);
  },

  listCountry() {
    const apis = jApi.generateApi();
    return apis.get('company/tools/countries')
      .then(res => res.data);
  },

  listProvince(req) {
    const apis = jApi.generateApi();
    return apis.post('company/tools/provinces', req)
      .then(res => res.data);
  },

  listCity(req) {
    const apis = jApi.generateApi();
    return apis.post('company/tools/cities', req)
      .then(res => res.data);
  },

  detailOrganigram(req) {
    const apis = jApi.generateApi();
    return apis.get(`jojoflow/v2/users/${req.user_company_id}/positions?limit=10&page=1&column=created_date&ascending=true`)
    // return apis.post('jojoflow/organigram/detail-by-user-company', req)
      .then(res => res.data);
  },

  listTeams(req) {
    const apis = jApi.generateApi();
    return apis.post('company/setup/team/list', req)
      .then(res => res.data);
  },

  getDivisionList(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/division/list', req)
      .then(res => res);
  },

  updateOrganigram(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/update', req)
      .then(res => res.data);
  },

  listPosition(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/list', req)
      .then(res => res.data);
  },
  getListAssignment(data) {
    const api = jApi.generateApi();
    return api.post('/hris-historical/report/list', data).then(res => res).catch(e => e);
  },
  getListAction(data) {
    const api = jApi.generateApi();
    return api.post('/hris-historical/action/list', data).then(res => res).catch(e => e);
  },
  updateReason(data) {
    const api = jApi.generateApi();
    return api.post('hris-historical/report/update', data).then(res => res).catch(e => e);
  },
  deleteListAssignment(data) {
    const api = jApi.generateApi();
    return api.post('/hris-historical/report/delete', data)
      .then(res => res);
  },

  getActivityLogs(data) {
    const api = jApi.generateApi();
    return api.get('/hris-historical-go-service/employee-activity-log/fetch?page=1&limit=1', data).then(res => res).catch(e => e);
  },

  getReasonList() {
    const api = jApi.generateApi();
    return api.get('/company/setup/reason/get-list').then(res => res.data).catch(e => e);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiUserEmployee.js